import { useState } from "react";

export default function ShareModal({ isOpen, onClose, onSubmit, file }) {
    const [recipientEmail, setRecipientEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({ recipientEmail, message, file });
        setRecipientEmail("");
        setMessage("");
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded shadow-md w-full max-w-md">
                <h3 className="text-xl font-semibold mb-4">Share Document</h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium">Recipient Email</label>
                        <input
                            type="email"
                            className="w-full border p-2 rounded"
                            value={recipientEmail}
                            onChange={(e) => setRecipientEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-2">Message (optional)</label>
                        <textarea
                            className="w-full border p-2 rounded"
                            rows="3"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                    </div>
                    <div className="flex justify-end space-x-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">Cancel</button>
                        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Send</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
